// extracted by mini-css-extract-plugin
export var iconContainer = "_fr-0";
export var metricCardsContainer = "_fr-1";